import { api } from './api';
import type {
  SubscriptionPlan,
  Subscription,
  CheckoutResponse,
} from '@dpfs/shared';

export const subscriptionsService = {
  async getPlans(): Promise<{ plans: SubscriptionPlan[] }> {
    const response = await api.get('/subscriptions/plans');
    return response.data;
  },

  async getCurrentSubscription(): Promise<{ subscription: Subscription | null }> {
    const response = await api.get('/subscriptions/current');
    return response.data;
  },

  async createCheckout(
    planId: string,
    billingInterval: 'MONTHLY' | 'YEARLY'
  ): Promise<CheckoutResponse> {
    const response = await api.post('/subscriptions/checkout', {
      planId,
      billingInterval,
    });
    return response.data;
  },

  async cancelSubscription(): Promise<void> {
    await api.post('/subscriptions/cancel');
  },
};
